import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { LineItemCustomPropertyInfo } from 'donor-elf-web/models/fund-setting';
import TransactionFilterOptionModel from 'donor-elf-web/models/transaction-filter-option';
import FundsService from 'donor-elf-web/services/funds-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Settings from 'donor-elf-web/services/settings';

export interface TransactionRouteModel {
  transTypes: string[];
  customProperties: LineItemCustomPropertyInfo[];
  hasAnonymous: boolean;
}

export default class TransactionsRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare settings: Settings;
  @service declare storeCache: any;

  beforeModel() {
    this.navbarSettings.title = 'Transactions';
  }

  // the controller takes care of fetching the actual records. the route just needs
  // to provide the values for the filters
  async model(): Promise<TransactionRouteModel> {
    let record = (await this.storeCache.findRecord(
      'transaction-filter-option',
      this.fundsService.selectedFund!.id,
    )) as TransactionFilterOptionModel;

    return {
      transTypes: record.transTypes,
      customProperties:
        this.settings.fundSettings!.lineItemCustomProperties || [],
      hasAnonymous: record.hasAnonymous,
    };
  }
}
